import sectionFreestyleCss from '../css-snippets/section-freestyle';

const html = `
<style>${sectionFreestyleCss}</style>
<div
  class=""
  data-attribute="wrap-content"
  data-top-padding="true"
  data-bottom-padding="true"
  data-layout-full-width="false"
  data-spacing-horizontal="true"
>
  <div class="container" data-attribute="content">
    <p style="text-align: center">
      <span class="text-big"
        ><strong>☕ Surprise in Every Sip: Hidden Message Mug 💬</strong></span
      >
    </p>
    <p>
      Not your average coffee cup. This clever
      <i>Hidden Message Mug for Office Warriors</i> keeps things interesting
      with a secret message that only reveals itself when viewed from just the
      right angle. Subtle, witty, and guaranteed to get a chuckle—it's your
      daily dose of humor with your caffeine hit.
    </p>
    <p style="text-align: center">
      <span class="text-big"><strong>Why You'll Love It 🚀</strong></span>
    </p>
    <p>
      <strong>🎁 A Gift with Personality</strong><br />This isn't just a
      mug—it's a conversation starter. Made from durable ceramic and holding
      11oz of coffee, tea, or whatever keeps you going, it's the perfect gift
      for coworkers, friends, or anyone who enjoys a clever twist.
    </p>
    <p>
      <strong>🎨 Bold Style, Subtle Message</strong><br />Available in different
      colors and design options, each mug adds a pop of personality to your
      kitchen or desk setup—while the hidden message keeps things playful.
    </p>
    <p>
      <strong>💪 Built to Last</strong><br />Premium ceramic ensures this mug
      holds up to daily use. Whether you're sipping at sunrise or powering
      through deadlines, it's ready for action.
    </p>
    <p>
      <strong>🙌 Hassle-Free Help</strong><br />Something not right? Our support
      team is here for you, 24/7. Fast responses, friendly service, no drama.
    </p>
    <p style="text-align: center">
      <span class="text-big"><strong>Care Instructions 🧼</strong></span>
    </p>
    <p>
      To preserve the design, hand wash or place on the top rack of your
      dishwasher. Skip the harsh scrubbing to keep the surprise message sharp
      and clear.
    </p>
    <p style="text-align: center">
      <span class="text-big"><strong>Specs 📏</strong></span>
    </p>
    <ul>
      <li><strong>Width:</strong> 8.2 cm / 3.23 in</li>
      <li><strong>Height:</strong> 9.5 cm / 3.74 in</li>
      <li><strong>Material:</strong> Ceramic</li>
    </ul>
    <p style="text-align: center">
      <span class="text-big"><strong>What's Inside 📦</strong></span>
    </p>
    <p>1 x Hidden Message Coffee Mug</p>
    <p>
      🔥
      <strong
        >Fuel your mornings, prank your coworkers, or just enjoy a little secret
        to yourself. Add some fun to your mug collection today!</strong
      >
    </p>
  </div>
</div>
`;
export default html;
